import { isStudyPlanId, type StudyPlanId } from "./study-plan";
import type { ScheduledTask } from "./study-plan-state";

export interface StudyTaskLink {
  planId: StudyPlanId;
  examSessionId: string;
  taskKey: string;
}

export function studyTaskHref(task: ScheduledTask, readOnly = false): string {
  if (readOnly || !task.attendanceEligible || !task.examSessionId)
    return task.path;
  const url = new URL(task.path, "https://study.invalid");
  url.searchParams.set("studyPlan", task.planId);
  url.searchParams.set("studySession", task.examSessionId);
  url.searchParams.set("studyTask", task.taskKey);
  return `${url.pathname}${url.search}${url.hash}`;
}

export function readStudyTaskLink(
  params: Pick<URLSearchParams, "get">,
): StudyTaskLink | null {
  const planId = params.get("studyPlan");
  const examSessionId = params.get("studySession");
  const taskKey = params.get("studyTask");
  if (
    !planId ||
    !isStudyPlanId(planId) ||
    !examSessionId ||
    !/^\d{4}-\d+$/.test(examSessionId) ||
    !taskKey ||
    taskKey.length > 500
  )
    return null;
  return { planId, examSessionId, taskKey };
}

export const STUDY_PAGE_COMPLETED = "gamja:study-page-completed";
export const STUDY_SCHEDULE_CHANGED = "gamja:study-schedule-changed";
export function notifyStudyScheduleChanged() {
  window.dispatchEvent(new Event(STUDY_SCHEDULE_CHANGED));
  try {
    localStorage.setItem(STUDY_SCHEDULE_CHANGED, String(Date.now()));
  } catch {
    /* 저장소 차단 환경에서도 현재 탭은 갱신한다. */
  }
}

/** 페이지를 떠난 뒤 도착한 출석 응답이 다른 일정까지 완료하지 않도록 한다. */
export function isSameStudyTaskLink(
  a: StudyTaskLink | null | undefined,
  b: StudyTaskLink,
): boolean {
  return (
    !!a &&
    a.planId === b.planId &&
    a.examSessionId === b.examSessionId &&
    a.taskKey === b.taskKey
  );
}
